export const therapistBaseAmount = [
    {
        base:82807,
        senior: 89533,
        seniorYearOneTwo:85047,
        seniorYearThreeFour:87289
    }
]

export const therapistPayIncrease = [
    {
        id: "0",
        expDiff: 0
    },
    {
        id: "3",
        expDiff: 1030
    },
    {
        id: "5",
        expDiff: 1550
    },
    {
        id: "10",
        expDiff: 2065
    },
]

export const therapistLongevity = [
    {
        id: "None",
        amount: 0
    },
    {
        id: "A/B (first year)",
        amount: 1962
    },
    {
        id: "A/B",
        amount: 3910
    },
    {
        id: "5 but less than 7",
        amount: 1283
    },
    {
        id: "7 but less than 10",
        amount: 3016
    },
    {
        id: "10 but less than 15",
        amount: 4159
    },
    {
        id: "15 but less than 20",
        amount: 14512
    },
    {
        id: "20 but less than 22",
        amount: 18616
    },
    {
        id: "22 years or more",
        amount: 24138
    }
]

export const therapistEducation = [
    {
        id: "Base Salary",
        amount: 0
    },
    {
        id: "Masters Differential",
        amount: 2620
    }
]